module.exports = __webpack_public_path__ + "static/media/Mountain_Biker.a0af2d44.jpg";